import { render, staticRenderFns } from "./page404.vue?vue&type=template&id=7184ff40&scoped=true"
import script from "./page404.vue?vue&type=script&lang=js"
export * from "./page404.vue?vue&type=script&lang=js"
import style0 from "./page404.vue?vue&type=style&index=0&id=7184ff40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7184ff40",
  null
  
)

export default component.exports